import { BaseComponent } from 'src/app/shared/base/BaseComponent';

export abstract class FlowStepBaseComponent extends BaseComponent {}
